module.exports = __webpack_public_path__ + "img/hr-red-pita-06.f3c87cd9.png";